export default "__VITE_ASSET__Csqje_ZK__"